import { render, staticRenderFns } from "./fases.vue?vue&type=template&id=6289d763"
import script from "./fases.vue?vue&type=script&lang=js"
export * from "./fases.vue?vue&type=script&lang=js"
import style0 from "./fases.vue?vue&type=style&index=0&id=6289d763&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports